import type { BannerWithWhiteTextContent } from '@/core/types';

import { BannerWithWhiteText } from '@/containers/blocks/banners';

export default function generate({
  content,
  className,
}: {
  content: BannerWithWhiteTextContent;
  className?: string;
}) {
  return (
    <BannerWithWhiteText
      title={content.title}
      titleTag={content.titleTag}
      description={content.description}
      image={content.image}
      className={className}
      buttons={content.buttons}
    />
  );
}
